export const buyerRequests = [
  {
    id: 1,
    buyerName: "James R.",
    buyerCountry: "USA",
    flag: "🇺🇸",
    avatar: "https://public.readdy.ai/ai/img_res/0017a6333187ed0725564f1b75fef7d6.jpg",
    category: "Vehicles & Transport",
    title: "Buy 50 Containers of Electric Golf Carts",
    description: "Looking to purchase 50 x 40ft containers of electric golf carts (4-seater and 6-seater). Must be CE certified, lithium battery, min 80km range. Delivery to Los Angeles port. Serious buyers only.",
    quantity: "50 Containers",
    budget: "$2,500,000 – $3,200,000",
    destination: "Los Angeles, USA",
    deadline: "Within 60 days",
    postedDate: "2 hours ago",
    verified: true,
    urgent: true,
    tags: ["Electric", "CE Certified", "Bulk Order"],
  },
  {
    id: 2,
    buyerName: "Mohammed A.",
    buyerCountry: "UAE",
    flag: "🇦🇪",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Middle%20Eastern%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer2&orientation=squarish",
    category: "Construction Materials",
    title: "Buy 100 Containers Steel Rebar (Grade 60)",
    description: "Urgently need 100 containers of Grade 60 steel rebar, sizes 12mm, 16mm, 20mm, 25mm. Must have mill certificate and SGS inspection. CIF Dubai port. Monthly orders possible for reliable supplier.",
    quantity: "100 Containers",
    budget: "$4,800,000 – $6,000,000",
    destination: "Dubai, UAE",
    deadline: "Within 30 days",
    postedDate: "5 hours ago",
    verified: true,
    urgent: true,
    tags: ["Grade 60", "SGS Inspection", "Monthly Orders"],
  },
  {
    id: 3,
    buyerName: "Sarah K.",
    buyerCountry: "Australia",
    flag: "🇦🇺",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Australian%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer3&orientation=squarish",
    category: "Furniture & Home",
    title: "Buy 30 Containers Sofa & Living Room Furniture",
    description: "Importing 30 containers of modern sofas, sectionals, coffee tables, and TV units for retail chain. Fabric and leather options needed. Must pass Australian safety standards. Sydney port delivery.",
    quantity: "30 Containers",
    budget: "$1,200,000 – $1,800,000",
    destination: "Sydney, Australia",
    deadline: "Within 45 days",
    postedDate: "8 hours ago",
    verified: true,
    urgent: false,
    tags: ["Retail Chain", "AU Safety Standard", "Modern Design"],
  },
  {
    id: 4,
    buyerName: "Carlos M.",
    buyerCountry: "Brazil",
    flag: "🇧🇷",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Brazilian%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer4&orientation=squarish",
    category: "Electronics",
    title: "Buy 20 Containers Smartphones & Tablets (OEM)",
    description: "Looking for OEM smartphone and tablet manufacturer. Need 20 containers mixed models, Android 14+, 4G/5G. Custom branding required. FCC/CE certified. Santos port, Brazil.",
    quantity: "20 Containers",
    budget: "$3,000,000 – $4,500,000",
    destination: "Santos, Brazil",
    deadline: "Within 90 days",
    postedDate: "1 day ago",
    verified: true,
    urgent: false,
    tags: ["OEM", "Android 14+", "Custom Brand"],
  },
  {
    id: 5,
    buyerName: "David L.",
    buyerCountry: "UK",
    flag: "🇬🇧",
    avatar: "https://readdy.ai/api/search-image?query=professional%20British%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer5&orientation=squarish",
    category: "Apparel & Textiles",
    title: "Buy 15 Containers Men's & Women's Clothing",
    description: "UK fashion retailer seeking 15 containers of men's and women's casual wear, activewear, and outerwear. Must comply with UK REACH regulations. Custom labels accepted. Felixstowe port.",
    quantity: "15 Containers",
    budget: "$600,000 – $900,000",
    destination: "Felixstowe, UK",
    deadline: "Within 50 days",
    postedDate: "1 day ago",
    verified: true,
    urgent: false,
    tags: ["UK REACH", "Custom Label", "Fashion Retail"],
  },
  {
    id: 6,
    buyerName: "Yuki T.",
    buyerCountry: "Japan",
    flag: "🇯🇵",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Japanese%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer6&orientation=squarish",
    category: "Food & Agriculture",
    title: "Buy 10 Containers Organic Frozen Seafood",
    description: "Japanese food distributor seeking 10 containers of frozen shrimp, squid, and fish fillets. Must be HACCP certified, BRC Grade A. Japan customs compliant. Yokohama port delivery.",
    quantity: "10 Containers",
    budget: "$800,000 – $1,200,000",
    destination: "Yokohama, Japan",
    deadline: "Within 40 days",
    postedDate: "2 days ago",
    verified: true,
    urgent: true,
    tags: ["HACCP", "BRC Grade A", "Frozen"],
  },
  {
    id: 7,
    buyerName: "Ahmed S.",
    buyerCountry: "Saudi Arabia",
    flag: "🇸🇦",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Saudi%20Arabian%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer7&orientation=squarish",
    category: "Construction Materials",
    title: "Buy 200 Containers Ceramic Floor & Wall Tiles",
    description: "Large construction project in Riyadh requires 200 containers of ceramic and porcelain tiles. Various sizes 60x60, 80x80, 120x60. Must have ISO 13006 certification. Jeddah port.",
    quantity: "200 Containers",
    budget: "$5,000,000 – $7,000,000",
    destination: "Jeddah, Saudi Arabia",
    deadline: "Within 120 days",
    postedDate: "2 days ago",
    verified: true,
    urgent: false,
    tags: ["ISO 13006", "Large Project", "Porcelain"],
  },
  {
    id: 8,
    buyerName: "Linda W.",
    buyerCountry: "Canada",
    flag: "🇨🇦",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Canadian%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer8&orientation=squarish",
    category: "Health & Beauty",
    title: "Buy 5 Containers Natural Skincare & Cosmetics",
    description: "Canadian beauty distributor seeking 5 containers of natural and organic skincare products. Must be Health Canada approved, cruelty-free, vegan certified. Vancouver port.",
    quantity: "5 Containers",
    budget: "$400,000 – $650,000",
    destination: "Vancouver, Canada",
    deadline: "Within 60 days",
    postedDate: "3 days ago",
    verified: true,
    urgent: false,
    tags: ["Health Canada", "Vegan", "Organic"],
  },
  {
    id: 9,
    buyerName: "Pierre D.",
    buyerCountry: "France",
    flag: "🇫🇷",
    avatar: "https://readdy.ai/api/search-image?query=professional%20French%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer9&orientation=squarish",
    category: "Machinery & Equipment",
    title: "Buy 8 Containers CNC Machines & Woodworking Equipment",
    description: "French manufacturing company needs 8 containers of CNC routers, laser cutters, and woodworking machinery. CE marked, full technical documentation required. Le Havre port.",
    quantity: "8 Containers",
    budget: "$1,500,000 – $2,200,000",
    destination: "Le Havre, France",
    deadline: "Within 75 days",
    postedDate: "3 days ago",
    verified: true,
    urgent: false,
    tags: ["CE Marked", "CNC", "Industrial"],
  },
  {
    id: 10,
    buyerName: "Raj P.",
    buyerCountry: "India",
    flag: "🇮🇳",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Indian%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer10&orientation=squarish",
    category: "Vehicles & Transport",
    title: "Buy 25 Containers Electric Scooters & E-Bikes",
    description: "Indian EV distributor seeking 25 containers of electric scooters and e-bikes. Must meet BIS certification, lithium battery, 60-100km range. Mumbai port. Long-term partnership preferred.",
    quantity: "25 Containers",
    budget: "$1,800,000 – $2,500,000",
    destination: "Mumbai, India",
    deadline: "Within 60 days",
    postedDate: "4 days ago",
    verified: true,
    urgent: true,
    tags: ["BIS Certified", "EV", "Long-term"],
  },
  {
    id: 11,
    buyerName: "Hans M.",
    buyerCountry: "Germany",
    flag: "🇩🇪",
    avatar: "https://readdy.ai/api/search-image?query=professional%20German%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer11&orientation=squarish",
    category: "Solar & Energy",
    title: "Buy 40 Containers Solar Panels & Inverters",
    description: "German renewable energy company needs 40 containers of monocrystalline solar panels (400W+) and hybrid inverters. TÜV certified, IEC 61215 compliant. Hamburg port.",
    quantity: "40 Containers",
    budget: "$3,200,000 – $4,800,000",
    destination: "Hamburg, Germany",
    deadline: "Within 90 days",
    postedDate: "4 days ago",
    verified: true,
    urgent: false,
    tags: ["TÜV Certified", "IEC 61215", "Renewable"],
  },
  {
    id: 12,
    buyerName: "Maria G.",
    buyerCountry: "Mexico",
    flag: "🇲🇽",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Mexican%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer12&orientation=squarish",
    category: "Furniture & Home",
    title: "Buy 12 Containers Office Furniture & Chairs",
    description: "Mexican office supply company seeking 12 containers of ergonomic office chairs, standing desks, and storage units. Modern design, BIFMA certified. Veracruz port.",
    quantity: "12 Containers",
    budget: "$480,000 – $720,000",
    destination: "Veracruz, Mexico",
    deadline: "Within 55 days",
    postedDate: "5 days ago",
    verified: true,
    urgent: false,
    tags: ["BIFMA", "Ergonomic", "Office"],
  },
  {
    id: 13,
    buyerName: "Kim J.",
    buyerCountry: "South Korea",
    flag: "🇰🇷",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Korean%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer13&orientation=squarish",
    category: "Food & Agriculture",
    title: "Buy 6 Containers Premium Coffee Beans",
    description: "Korean coffee chain seeking 6 containers of Arabica and Robusta green coffee beans from Ethiopia, Colombia, Brazil. Rainforest Alliance certified. Busan port.",
    quantity: "6 Containers",
    budget: "$350,000 – $500,000",
    destination: "Busan, South Korea",
    deadline: "Within 35 days",
    postedDate: "5 days ago",
    verified: true,
    urgent: true,
    tags: ["Arabica", "Rainforest Alliance", "Premium"],
  },
  {
    id: 14,
    buyerName: "Fatima O.",
    buyerCountry: "Nigeria",
    flag: "🇳🇬",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Nigerian%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer14&orientation=squarish",
    category: "Construction Materials",
    title: "Buy 60 Containers Cement & Building Materials",
    description: "Nigerian construction firm needs 60 containers of Portland cement, roofing sheets, and PVC pipes. NAFDAC compliant. Lagos port. Recurring monthly orders for right supplier.",
    quantity: "60 Containers",
    budget: "$2,000,000 – $2,800,000",
    destination: "Lagos, Nigeria",
    deadline: "Within 45 days",
    postedDate: "6 days ago",
    verified: true,
    urgent: true,
    tags: ["NAFDAC", "Monthly Orders", "Construction"],
  },
  {
    id: 15,
    buyerName: "Tom B.",
    buyerCountry: "Netherlands",
    flag: "🇳🇱",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Dutch%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer15&orientation=squarish",
    category: "Electronics",
    title: "Buy 10 Containers Smart Home Devices & IoT",
    description: "Dutch tech distributor seeking 10 containers of smart home devices: smart bulbs, plugs, cameras, doorbells, thermostats. CE/RoHS certified. Rotterdam port.",
    quantity: "10 Containers",
    budget: "$900,000 – $1,400,000",
    destination: "Rotterdam, Netherlands",
    deadline: "Within 50 days",
    postedDate: "6 days ago",
    verified: true,
    urgent: false,
    tags: ["CE/RoHS", "Smart Home", "IoT"],
  },
  {
    id: 16,
    buyerName: "Anna V.",
    buyerCountry: "Russia",
    flag: "🇷🇺",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Russian%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer16&orientation=squarish",
    category: "Apparel & Textiles",
    title: "Buy 20 Containers Winter Jackets & Coats",
    description: "Russian fashion wholesaler needs 20 containers of winter jackets, down coats, and thermal wear. Sizes XS-4XL. Custom labels available. St. Petersburg port.",
    quantity: "20 Containers",
    budget: "$700,000 – $1,100,000",
    destination: "St. Petersburg, Russia",
    deadline: "Within 70 days",
    postedDate: "1 week ago",
    verified: true,
    urgent: false,
    tags: ["Winter Wear", "Custom Label", "Wholesale"],
  },
  {
    id: 17,
    buyerName: "Omar F.",
    buyerCountry: "Egypt",
    flag: "🇪🇬",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Egyptian%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer17&orientation=squarish",
    category: "Food & Agriculture",
    title: "Buy 15 Containers Frozen Chicken & Meat Products",
    description: "Egyptian food importer seeking 15 containers of frozen whole chicken, chicken parts, and beef cuts. Halal certified, USDA/EU approved. Alexandria port.",
    quantity: "15 Containers",
    budget: "$1,100,000 – $1,600,000",
    destination: "Alexandria, Egypt",
    deadline: "Within 30 days",
    postedDate: "1 week ago",
    verified: true,
    urgent: true,
    tags: ["Halal", "USDA Approved", "Frozen"],
  },
  {
    id: 18,
    buyerName: "Isabella C.",
    buyerCountry: "Italy",
    flag: "🇮🇹",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Italian%20businesswoman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer18&orientation=squarish",
    category: "Machinery & Equipment",
    title: "Buy 5 Containers Textile Machinery & Spare Parts",
    description: "Italian textile manufacturer seeking 5 containers of weaving machines, knitting machines, and spare parts. CE certified, full warranty required. Genoa port.",
    quantity: "5 Containers",
    budget: "$2,000,000 – $3,000,000",
    destination: "Genoa, Italy",
    deadline: "Within 80 days",
    postedDate: "1 week ago",
    verified: true,
    urgent: false,
    tags: ["CE Certified", "Textile", "Full Warranty"],
  },
  {
    id: 19,
    buyerName: "Chen W.",
    buyerCountry: "Singapore",
    flag: "🇸🇬",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Singaporean%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer19&orientation=squarish",
    category: "Solar & Energy",
    title: "Buy 3 Containers Lithium Battery Storage Systems",
    description: "Singapore energy company needs 3 containers of commercial lithium battery energy storage systems (100kWh+). UL/IEC certified, BMS included. Singapore port.",
    quantity: "3 Containers",
    budget: "$1,500,000 – $2,200,000",
    destination: "Singapore",
    deadline: "Within 60 days",
    postedDate: "1 week ago",
    verified: true,
    urgent: false,
    tags: ["UL/IEC", "100kWh+", "BMS Included"],
  },
  {
    id: 20,
    buyerName: "Robert N.",
    buyerCountry: "South Africa",
    flag: "🇿🇦",
    avatar: "https://readdy.ai/api/search-image?query=professional%20South%20African%20businessman%20portrait%20confident%20clean%20white%20background%20headshot&width=80&height=80&seq=buyer20&orientation=squarish",
    category: "Vehicles & Transport",
    title: "Buy 18 Containers Forklifts & Warehouse Equipment",
    description: "South African logistics company seeking 18 containers of electric forklifts (1.5T–5T), pallet jacks, and shelving systems. SABS approved. Durban port.",
    quantity: "18 Containers",
    budget: "$2,200,000 – $3,000,000",
    destination: "Durban, South Africa",
    deadline: "Within 75 days",
    postedDate: "2 weeks ago",
    verified: true,
    urgent: false,
    tags: ["SABS Approved", "Electric", "Warehouse"],
  },
];

export const buyerCategories = [
  "All",
  "Vehicles & Transport",
  "Construction Materials",
  "Furniture & Home",
  "Electronics",
  "Apparel & Textiles",
  "Food & Agriculture",
  "Health & Beauty",
  "Machinery & Equipment",
  "Solar & Energy",
];
